import { render } from "./ClassListCard1.vue?vue&type=template&id=70e642e1&scoped=true"
import script from "./ClassListCard1.vue?vue&type=script&lang=js"
export * from "./ClassListCard1.vue?vue&type=script&lang=js"

import "./ClassListCard1.vue?vue&type=style&index=0&id=70e642e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e642e1"]])

export default __exports__